import React, { useState } from 'react'
import { Formik, Form, ErrorMessage } from 'formik'
import {
  Col,
  Row,
  Form as BForm,
  Button,
  Tabs,
  Tab
} from '@themesberg/react-bootstrap'
import { createCmsNewSchema } from '../schema'
import useCreateCms from '../hooks/useCreateCms'
import ClientFilter from '../../../../components/ClientFilter'
import PortalFilter from '../../../../components/PortalFilter'
import useCheckPermission from '../../../../utils/checkPermission'
import Trigger from '../../../../components/OverlayTrigger'
import { faImages } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { GalleryModal } from '../../../../components/ConfirmationModal'
import { AdminsRoutes } from '../../../../routes'
import { CreateCMSTemplate } from '../../../../components/EditCMSTemplate/CreateCMSTemplate'
import { languageCode } from '../../../Tenant/TenantConfigurations/Languages/constants'
import { toast } from '../../../../components/Toast'
import Toggle from '../../TransactionsDriver/components/Toggle'
import PageBackButton from '../../../../components/PageBackButton'
import {categoryLinkOptions} from "../constants"

const CreateCMSNew = () => {
  const {
    navigate,
    createCms,
    selectedClient,
    selectedPortal,
    setSelectedClient,
    setSelectedPortal,
    galleryModal,
    setGalleryModal,
    getGalleryData,
    cmsKeys,
    selectedTab,
    setSelectedTab,
    languages,
    deleteCms
  } = useCreateCms()

  const { isHidden } = useCheckPermission()
  const [title, setTitle] = useState({ EN: '' })
  const [content, setContent] = useState({ EN: '' })

  return (
    <>
      <div className='section-header-wrap mt-n3 mx-n3'>
        <Row>
          <Col sm={8}>
          <div className='backbtn'>
            <PageBackButton />
            <h2 className='title-text'>Create CMS</h2>
          </div>
           
          </Col>
          {/* <Col className='d-flex justify-content-end'>
            <Trigger message='Gallery'>
              <Button
                hidden={isHidden({ module: { key: 'ImageGallery', value: 'R' } })}
                onClick={() => {
                  getGalleryData()
                  setGalleryModal(true)
                }}
                variant='btn btn-primary'
              >
                <FontAwesomeIcon icon={faImages} />
              </Button>
            </Trigger>
          </Col> */}
        </Row>
      </div>
      <div className='FormsBg'>
        <Formik
          initialValues={{
            title: title?.EN || '',
            slug: '',
            content: content?.EN || '',
            category: 1,
            isActive: true
          }}
          validationSchema={createCmsNewSchema}
          onSubmit={(formValues) => {
            for (const lang in title) {
              if (([undefined, ''].includes(content?.[lang]) && [undefined, ''].includes(title?.[lang]))) {
                delete title[lang]
                delete content[lang]
              }
            }
            console.log('on submit');
            createCms({ cmsData: { ...formValues, title, content, tenantId: selectedPortal, adminUserId: selectedClient } })
          }}
        >
          {({ values, errors, handleChange, handleSubmit, handleBlur, setFieldValue }) => (
            <Form>
              {/* Responsive Form Controls Row */}
              <Row className='mb-4 g-3'>
                {/* Slug Input - Full width on mobile, half on tablet+ */}
                <Col xs={12} md={6} lg={5}>
                  <div className="form-group">
                    <label htmlFor="slug" className="form-label fw-semibold mb-2">
                      Slug <span className="text-danger">*</span>
                    </label>
                    <BForm.Control
                      type='text'
                      name='slug'
                      id='slug'
                      placeholder='Enter Slug'
                      value={values.slug}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    // className="form-control-lg"
                    />
                    <ErrorMessage
                      component='div'
                      name='slug'
                      className='text-danger small mt-1'
                    />
                  </div>
                </Col>

                {/* Category Select - Full width on mobile, quarter on tablet+ */}
                <Col xs={12} md={6} lg={3}>
                  <div className="form-group">
                    <label htmlFor="category" className="form-label fw-semibold mb-2">
                      Category
                    </label>
                    <BForm.Select
                      name='category'
                      id='category'
                      value={values.category}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="form-select-lg"
                    >
                      {/* <option value={1}>Support Links</option>
                      <option value={2}>Other Links</option> */}
                  {categoryLinkOptions.map(option => (
    <option key={option.value} value={option.value}>
      {option.label} 
    </option>
  ))}
                    </BForm.Select>
                  </div>
                </Col>

                {/* Status Toggle - Full width on mobile, quarter on tablet+ */}
                <Col xs={12} lg={3}>
                  <div className="form-group">
                    <label className="form-label fw-semibold mb-2 d-block">
                      Status
                    </label>
                    <div className="d-flex align-items-center justify-content-between p-3 py-2 border rounded bg-light">
                      <div className="flex-grow-1">
                        <span className={`fw-medium ${values.isActive ? 'text-success' : 'text-muted'}`}>
                          {values.isActive ? 'Active' : 'Inactive'}
                        </span>
                        {/* <div className="small text-muted">
                          {values.isActive ? 'Content is published' : 'Content is draft'}
                        </div> */}
                      </div>
                      <Toggle
                        checked={values.isActive}
                        onChange={(e) => {
                          setFieldValue('isActive', e.target.checked)
                        }}
                        size="small"
                        justify="center"
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              {/* Commented out Client/Portal Filters - keeping for reference */}
              {/* <Row className='mt-3 d-flex'>
                <Col xs={12} md={6}>
                  <ClientFilter
                    setSelectedClient={setSelectedClient}
                    setSelectedPortal={setSelectedPortal}
                    selectedClient={selectedClient}
                    cmsData
                  />
                </Col>

                {selectedClient && (
                  <Col xs={12} md={6}>
                    <PortalFilter
                      setSelectedPortal={setSelectedPortal}
                      selectedPortal={selectedPortal}
                      selectedClient={selectedClient}
                      cmsData
                    />
                  </Col>
                )}
              </Row> */}

              {/* CMS Template Section */}
              <div className='mt-4'>
                <CreateCMSTemplate
                  cmsKeys={cmsKeys}
                  setFieldValue={setFieldValue}
                  isHidden={isHidden}
                  selectedTab={selectedTab}
                  setSelectedTab={setSelectedTab}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  handleSubmit={handleSubmit}
                  navigate={navigate}
                  deleteCms={deleteCms}
                  initValues={values}
                  errors={errors}
                  title={title}
                  setTitle={setTitle}
                  content={content}
                  setContent={setContent}
                />
              </div>

              {/* Action Buttons - Responsive */}
              <Row className='mt-4'>
                <Col xs={12}>
                  <div className='d-flex flex-column flex-sm-row justify-content-between gap-2'>
                    <Button
                      variant='outline-warning'
                      className='order-2 order-sm-1'
                      onClick={() => {
                        navigate(AdminsRoutes.CMS)
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant='outline-success'
                      hidden={isHidden({ module: { key: 'CMS', value: 'U' } })}
                      className='order-1 order-sm-2'
                      onClick={() => {
                        // if (content?.EN === '') {
                        //   toast('Content for English is Required', 'error')
                        // } else {
                        //   if (title?.EN === '') {
                        //     toast('Title for English is Required', 'error')
                        //     window.scroll(0, 0)
                        //   } else if (errors.slug) {
                        //     window.scroll(0, 0)
                        //     handleSubmit()
                        //   } else {
                        handleSubmit()
                        // }
                      }
                      }
                    >
                      Create CMS
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </div>
      {galleryModal &&
        <GalleryModal
          galleryModal={galleryModal}
          setGalleryModal={setGalleryModal}
        />}
    </>
  )
}

export default CreateCMSNew
